<div class="pageheader">
  <!--<h1>Welcome back!</h1>-->
</div>

<div class="pagecontent">
  <app-survey-page></app-survey-page>
</div>
